<template>
    <div>
        <Modal
            :id="modalId"
            is-dark
            is-without-body
            is-without-close
            is-strict
            is-full>
            <div
                class="uk-position-relative uk-visible-toggle uk-modal-close"
                tabindex="-1"
                uk-height-viewport
                :id="slideshowId"
                :uk-slideshow="getSlideShowSettings()">
                <ul class="uk-slideshow-items" uk-height-viewport>
                    <li v-for="(screensaver, key) in terminal.ads" :key="key">
                        <div class="uk-position-cover">
                            <video
                                v-if="screensaver && isVideo(screensaver)"
                                muted
                                oncontextmenu="return false;"
                                playsinline
                                uk-cover>
                                <source
                                    :src="
                                        apiUrl + '/terminal-ads/' + screensaver
                                    "
                                    :type="
                                        'video/' + getVideoType(screensaver)
                                    " />
                            </video>
                            <img
                                v-else-if="screensaver"
                                :src="apiUrl + '/terminal-ads/' + screensaver"
                                class="uk-background-cover uk-animation-kenburns uk-animation-reverse"
                                uk-cover />
                        </div>
                    </li>
                </ul>

                <div class="uk-position-center">
                    <!-- the terminal page's look: the pictures slide out of a
                         printer's slot one after another -->
                    <div v-if="isStudio" class="studio-print-card">
                        <div class="studio-print-title">
                            {{ $t('order.created.title') }}
                        </div>
                        <Translate
                            class="studio-print-text"
                            :translation-key="
                                parsedPictures.length === 1
                                    ? 'print.message.singular'
                                    : 'print.message.plural'
                            " />

                        <div class="studio-print">
                            <div class="studio-print-slot" />
                            <div class="studio-print-paper">
                                <img
                                    v-if="parsedPictures[status]"
                                    :key="'print' + status"
                                    :src="
                                        parsedPictures[status]
                                            .thumbnailCroppedUrl
                                    "
                                    class="studio-print-photo" />
                            </div>
                        </div>

                        <Translate
                            class="studio-print-status"
                            translation-key="print.status"
                            :parameter="{
                                current: status + 1,
                                total: parsedPictures.length,
                            }" />
                        <progress
                            class="uk-progress studio-print-progress"
                            :value="status + 1"
                            :max="parsedPictures.length" />

                        <Button
                            :action="close"
                            :text="$t('close')"
                            has-action
                            is-round
                            mode="default"
                            class="studio-print-close" />
                    </div>
                    <div v-else class="uk-margin-xlarge-bottom uk-light">
                        <Card mode="blur" class="uk-text-center">
                            <ModalTitle :title="$t('order.created.title')" />

                            <Description>
                                <Translate
                                    class="print-description"
                                    :translation-key="
                                        parsedPictures.length === 1
                                            ? 'print.message.singular'
                                            : 'print.message.plural'
                                    " />
                            </Description>

                            <div class="uk-margin-small-bottom">
                                <div
                                    class="uk-position-relative uk-visible-toggle uk-height-small"
                                    tabindex="-1"
                                    :id="slideshowIdPrinting"
                                    uk-slideshow="draggable: false; ratio: false;">
                                    <ul
                                        class="uk-slideshow-items uk-height-small">
                                        <li
                                            v-for="picture in parsedPictures"
                                            :key="picture.originKey">
                                            <img
                                                :src="
                                                    picture.thumbnailCroppedUrl
                                                "
                                                class="uk-height-small" />
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <Translate
                                class="print-status"
                                translation-key="print.status"
                                :parameter="{
                                    current: status + 1,
                                    total: parsedPictures.length,
                                }" />
                        </Card>
                    </div>
                </div>

                <div class="uk-position-bottom-center">
                    <div
                        class="uk-flex uk-flex-center uk-margin-bottom powered">
                        {{ terminal.screensaversText }}
                    </div>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import Modal from '@/components/generic/Modal.vue';
import UIkit from 'uikit';
import ModalTitle from '@/components/generic/ModalTitle.vue';
import Card from '@/components/generic/Card.vue';
import Description from '@/components/Description.vue';
import Translate from '@/components/Translate.vue';
import Button from '@/components/generic/Button.vue';

export default {
    name: 'TerminalAdsScreensaver',
    components: {Translate, Description, Card, ModalTitle, Modal, Button},
    props: {
        pictures: Array,
        // MainTerminal: the studio card with the printing pictures
        isStudio: Boolean,

        terminal: {
            screensavers: Array,
            screensaversText: String,
            sliderInterval: Number,
            sliderVideoAdjusted: Boolean,
            hasAds: Boolean,
            ads: Array,
        },
    },
    data() {
        return {
            status: 0,
            interval: 0,

            modalId: 'modal-terminal-ads-screensaver',
            slideshowId: 'slideshow-terminal-ads-screensavers',

            slideshowIdPrinting: 'slideshow-printing',

            parsedPictures: [],
        };
    },
    created() {
        let parsed = [];

        let pictures = this.pictures;
        for (let i = 0, j = pictures.length; i < j; i++) {
            const picture = pictures[i];

            for (let k = 0, l = picture.amount; k < l; k++) {
                parsed.push(picture);
            }
        }

        this.parsedPictures = parsed;
    },
    mounted() {
        let self = this;
        this.interval = setInterval(
            function () {
                self.updateStatus();
            },
            this.isStudio ? 2500 : 5000
        );

        if (this.terminal.sliderVideoAdjusted) {
            const slideshow = UIkit.slideshow('#' + this.slideshowId);
            const slideshowElement = document.getElementById(this.slideshowId);
            slideshowElement.addEventListener('itemshow', (event) => {
                const element = event.target.children[0].children[0];
                const currentIndex = event.detail[0].index;

                let nextIndex = currentIndex + 1;
                if (this.terminal.screensavers.length > nextIndex) {
                    nextIndex = 0;
                }

                if (element && element.tagName === 'VIDEO') {
                    slideshow.stopAutoplay();

                    element.addEventListener('ended', () => {
                        slideshow.show(nextIndex);
                        slideshow.startAutoplay();
                    });
                }
            });
        }
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
    methods: {
        updateStatus() {
            const nextStatus = this.status + 1;
            if (nextStatus >= this.parsedPictures.length) {
                this.$emit('ended');
                return;
            }

            if (!this.isStudio) {
                UIkit.slideshow('#' + this.slideshowIdPrinting).show(
                    nextStatus
                );
            }

            this.status = nextStatus;
        },
        // the view cancelled: the same fresh start as when the printing ends
        close() {
            clearInterval(this.interval);
            this.$emit('ended');
        },
        getSlideShowSettings() {
            let interval = this.terminal.sliderInterval * 1000;

            return (
                'ratio: false; autoplay: true; autoplay-interval: ' +
                interval +
                '; draggable: false; animation: push; pause-on-hover: false;'
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.start-struct {
    min-width: 300px;
    width: 25vw;
}

.uk-slideshow-items {
    opacity: 0.8;
}

.powered {
    font-size: $site-font-size-large;
    color: $site-color;
}

.print-description {
    font-size: 20px;
}

.print-status {
    font-size: 18px;
}

// studio look (MainTerminal): a white card, the pictures coming out of a slot

.studio-print-card {
    width: calc(100vw - 48px);
    max-width: 560px;
    padding: 32px;
    border-radius: 16px;
    background: #fff;
    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.3);
    color: $site-background;
    text-align: center;
}

.studio-print-title {
    font-size: 26px;
    font-weight: 500;
}

.studio-print-text {
    display: block;
    margin-top: 6px;
    color: #707070;
    font-size: 18px;
}

.studio-print {
    width: 340px;
    max-width: 100%;
    margin: 28px auto 0 auto;
}

.studio-print-slot {
    position: relative;
    z-index: 1;
    height: 18px;
    border-radius: 9px;
    background: #121212;
}

// clipped at the slot's middle, so the photo comes out from behind it
.studio-print-paper {
    height: 260px;
    margin: -9px 22px 0 22px;
    overflow: hidden;
}

.studio-print-photo {
    display: block;
    max-width: 100%;
    max-height: 100%;
    margin: 0 auto;
    border: 8px solid #fff;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18);
    // shorter than the 2.5 s per picture, so each one rests a moment
    animation: studio-print-out 2s cubic-bezier(0.2, 0.7, 0.3, 1) both;
}

@keyframes studio-print-out {
    from {
        transform: translateY(-105%);
    }

    to {
        transform: translateY(0);
    }
}

.studio-print-status {
    display: block;
    margin-top: 20px;
    font-size: 18px;
}

.studio-print-progress {
    height: 6px;
    margin: 12px 0 0 0;
}

.studio-print-close {
    margin-top: 24px;
}
</style>
